import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=4066371f&scoped=true"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"
import style0 from "./AddressComponent.vue?vue&type=style&index=0&id=4066371f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066371f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4066371f')) {
      api.createRecord('4066371f', component.options)
    } else {
      api.reload('4066371f', component.options)
    }
    module.hot.accept("./AddressComponent.vue?vue&type=template&id=4066371f&scoped=true", function () {
      api.rerender('4066371f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/AddressComponent.vue"
export default component.exports